<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 417 417"
    class="svg-icon"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
  >
    <path
      d="M209.75,17.042c104.257,0.978 189.497,87.021 189.497,191.283c-0,104.939 -86.352,191.292 -191.292,191.292c-104.939,-0 -191.291,-86.353 -191.291,-191.292c-0,-0.358 0.001,-0.717 0.003,-1.075c0.797,-105.131 87.952,-190.988 193.083,-190.208Zm-1.667,16.625c-95.609,0.135 -174.317,78.6 -174.75,174.208c-0,0.153 -0,0.306 -0,0.458c-0,95.82 78.847,174.667 174.666,174.667c95.82,-0 174.667,-78.847 174.667,-174.667c0,-95.787 -78.795,-174.62 -174.583,-174.666Z"
      style="fill-rule:nonzero;"
    />
    <path
      d="M225,238.333l0,45.625c0,7.417 -3.5,16.167 10.833,16.167c7.834,0 5.375,6.208 5.625,10.542c0.375,6.333 -4.458,5.75 -8.333,5.791l-49.792,0c-4.166,0 -8.708,0 -8.333,-6.166c0.333,-4.417 -1.75,-10.209 6.042,-10.209c13.125,0 10.541,-12.5 10.541,-17.125l0,-75.875c0,-7.416 1.792,-15.458 -9.625,-15.458c-7.625,0 -6.75,-4.625 -7.041,-9.5c-0.459,-7.5 4.166,-7.083 9.458,-7.083l2.083,-0c38.584,-0 38.459,-0.834 38.459,36.291l0.083,27Z"
      style="fill-rule:nonzero;"
    />
    <circle cx="208.167" cy="116.25" r="25.792" />
  </svg>
</template>

<script>
export default {
  name: "IconInfo"
};
</script>
